import { RootAppState } from 'store/configureStore'

export const projectOrderNumberSelector = (state: RootAppState) => {
  return state.project.activeProject?.orderNumber
}
